// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PVU1y","label":"styles_label__1SSPB"};